// Get the modal
(function ($) {
    function removeHash() {
        window.history.pushState("", document.title, window.location.pathname);
    }

    $('body.page--job-detail').html(function () {
        var modal = document.getElementById("applyModal");

        // Get the button that opens the modal
        var btn = document.getElementById("applyBtn");

        // Get the <span> element that closes the modal
        var close = document.getElementsByClassName("close")[0];

        // When the user clicks on the button, open the modal
        btn.onclick = function () {
            const currentUrl = window.location.href;

            modal.style.display = "flex";
            window.location.href = currentUrl + '#applyModal';
        }

        // When the user clicks on <span> (x), close the modal
        close.onclick = function () {
            modal.style.display = "none";
            removeHash();
        }

        // When the user clicks anywhere outside of the modal, close it
        window.onmousedown = function (event) {
            if (event.target === modal) {
                modal.style.display = "none";
                removeHash();
            }
        }

        if (window.location.href.indexOf('#applyModal') !== -1) {
            modal.style.display = "flex";
        }
    });

    $('body.page--event-detail').html(function () {
        var modal = document.getElementById("registerModal");

        // Get the button that opens the modal
        var btn = document.getElementById("registerBtn");

        // Get the <span> element that closes the modal
        var close = document.getElementsByClassName("close")[0];

        // When the user clicks on the button, open the modal
        if ($(btn).length > 0) {
            btn.onclick = function () {
                const currentUrl = window.location.href;

                modal.style.display = "flex";
                window.location.href = currentUrl + '#registerModal';
            }

            // When the user clicks anywhere outside of the modal, close it
            window.onmousedown = function (event) {
                if (event.target === modal) {
                    modal.style.display = "none";
                    removeHash();
                }
            }
        }

        // When the user clicks on <span> (x), close the modal
        close.onclick = function () {
            modal.style.display = "none";
            removeHash();
        }

        if (window.location.href.indexOf('#registerModal') !== -1) {
            modal.style.display = "flex";
        }
    });

})(jQuery);

